module.exports = __webpack_public_path__ + "img/interpackmaxi-active.3cb8dc95.svg";